<template>
  <div class="quotegraph-div">
    <quote-view
      class="graph1"
      ref="graph"
      :cid="cid"
      :token="token"
      :params="params"
      :code="code"
      :appkey="appkey"
      :throttle="throttle"
      :option="option"
      :graphConfig="graphConfig1"
      :period-black-list="periodBlackList"
      :multi-main-modules="multiMainModules"
      :multi-main-auths="multiMainAuths"
      :multi-foot-modules="multiFootModules"
      :multi-foot-auths="multiFootAuths"
      :moveKey="moveKey"
      :instantId="1"
    ></quote-view>
    <quote-view
      v-show="showIndicatorQuoteView"
      class="graph2"
      ref="graph2"
      :cid="cid"
      :token="token"
      :params="params"
      :code="code"
      :mainKey="mainKey"
      :scaleKey="scaleKey"
      :rightKey="rightKey"
      :appkey="appkey"
      :throttle="throttle"
      :option="option2"
      :graphConfig="graphConfig2"
      :period-black-list="periodBlackList"
      :multi-main-modules="multiMainModules2"
      :multi-main-auths="multiMainAuths2"
      :multi-foot-modules="multiFootModules2"
      :multi-foot-auths="multiFootAuths2"
      :moveKey="moveKey"
      :instantId="2"
      :business_type="business_type"
    ></quote-view>
    <tab-tag @changeFootView="changeFootView" :footView="footView" :mainView="mainKey" v-show="showTrendTab"></tab-tag>
    <ktab-tag @changeFootKView="changeFootKView" :noTabName="noTabName" :footView="footView" :mainView="mainKey" v-show="showKTab"></ktab-tag>
  </div>
</template>
<script>
import QuoteView from "./index.vue";
import Bus from "../eventBus.js";
import TabTag from "./TabeTag.vue";
import KtabTag from "./KtabTag.vue";
import { checkExchange } from '../../../packages/controller/util'
import Controller from '../../controller/index.js';
export default {
  name: "quoteGraph",
  components: {
    QuoteView,
    TabTag,
    KtabTag
  },
  props: {
    code: {
      type: String,
      requires: true
    },
    throttle: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      noTabName:[],
      footView:null,
      showIndicatorQuoteView: true, // 是否展示指标部分
      showTrendTab: true, // 分时的指标
      showKTab: false, //看线的
      mainKey: null, // 用于传递给指标部分的头部key
      rightKey: 0, // 除权前复后复
      scaleKey: [], // 缩放操作
      business_type:'1',
      moveKey: {}, // 鼠标移动的坐标位置
      cid: "",
      appkey: "",
      token: "",
      params: {
        push_type: "3",
        app_key: "1",
        sand_box: 0
      },
      periodBlackList: [],
      kkey:0,
      /**
       * [multiModules 将需要展示的模块相加即可]
       * 主视图模块
       * const TREND_KEY = 1; // 分时
       * const MA_KEY = 2; // 均线
       * * const KD_KEY = 8; // KD密码
       * const BOLL_KEY = 32; // BOLL
       * const AREA_KEY = 64; // 分时折线图
       */
      multiMainModules: 99,
      multiMainAuths: 99,
      multiMainModules2: 0,
      multiMainAuths2: 11,
      /**
       * 辅视图模块
       * const AMOUNT_KEY = 1; // 成交量
       * const MACD_KEY = 2; // MACD
       * const KDJ_KEY = 4;  // KDJ
       * const ENE_KEY = 8; // ENE
       * const ELECTRIC_KEY = 16;  // 电波
       * const FUNDFLOW_KEY = 32;  // 资金博弈
       * const FUNDFLOWDIR_KEY = 64;  // 资金流向
       * * const DMA_KEY=128//DMA指标 *
       * const VR_KEY=256
       * const WR_KEY=512
       * const OBV_KEY=1024
       * const DMI_KEY=2048
       * const RSI_KEY=4096
       * const PSY_KEY=8192
       * const LIANGBI_KEY=16384
       */
      multiFootModules: 1,
      multiFootAuths: 1,
      multiFootModules2: 16262,
      multiFootAuths2: 16262,
      option: {
        // remTopx: 50,
        showTabBar: true, // 是否显示分时K线tab切换栏
        showFullScreenBtn: false, // 是否显示全屏按钮
        showSideDetail: true, // 是否显示分时五档明细成交量
        showFundflow: false, // 是否显示分时五档的成交量
        supportFullScreen: false, // 是否支持全屏
        supportKlineRight: true, // 是否支持除复权
        supportKlineScale: true, // 是否支持K线缩放
        supportKlineFootMenu: false, // 是否显示全屏K线菜单栏
        supportGestures: true // 是否支持手势操作
      },
      option2: {
        showTabBar: false, // 是否显示分时K线tab切换栏
        // showFullScreenBtn: false, // 是否显示全屏按钮
        // showSideDetail: false, // 是否显示分时五档明细成交量
        // showFundflow: false, // 是否显示分时五档的成交量
        // supportFullScreen: false, // 是否支持全屏
        // supportKlineRight: false, // 是否支持除复权
        // supportKlineScale: false, // 是否支持K线缩放
        supportKlineFootMenu: false, // 是否显示全屏K线菜单栏
        supportGestures: true // 是否支持手势操作
      },
      graphConfig1: {
          // FootContext: {
          //   size: {
          //     top: 2
          //   }
          // }
      },
      graphConfig2: {
        // /*** 辅视图 ***/
        FootContext: {
          size: {
            bottom: 0,
            top: -2 // 占据空白的主视图空间
          },
          axisX: null
        }
      }
    };
  },
  created() {
      if(checkExchange(this.code)){
          this.periodBlackList=[ 1,2,3,4,5,10,11 ]
          this.graphConfig1={
              Component: {
                  mainViewOption: {
                      bottom: 0.03
                  },
                  footViewOption: {
                      top: 0.97,
                  },
              },
              FootContext: {
                  size: {
                      top: 2
                  }
              }
          }
          this.multiMainAuths = 34
          this.multiMainModules = 34
          this.noTabName=['OBV']
      }
    // 切换头部tab
    Bus.$on("getBusTapKey", target => {
      if (!target || target[0] != this.code) {
        return;
      }
      if (target[1] === 11 || target[1] === 12) {
        // 五日不展示指标模块
        this.showTrendTab = false;
        this.showIndicatorQuoteView = false;
        this.showKTab = false;
      } else if (target[1] === 10) {
        // 分时
        this.showIndicatorQuoteView = true;
        this.showTrendTab = true;
        this.showKTab = false;
      } else {
        // k线
        this.showIndicatorQuoteView = true;
        this.showTrendTab = false;
        this.showKTab = true;
      }
      this.mainKey = target[1];
    });
    // 切换除权、前复、后复
    Bus.$on("changeKlineStatus", target => {
      this.rightKey = target;
    });
    Bus.$on("indicatorScale", target => {
      this.scaleKey = [target, new Date()];
    });
    Bus.$on("changeForeign", target => {
        this.business_type = target;
    });
    Bus.$on("mouseMoving", target => {
      this.moveKey = target;
    });
  },
  methods: {
    changeFootView(key) {
        this.$refs.graph2.changeFootState(key);
        this.footView=key
    },
    changeFootKView(key) {
      this.$refs.graph2.changeFootState(key);
      this.footView=key
    }
  }
};
</script>
<style lang="scss" scoped>

.graph1 {
  height: 77%;
}
.graph2 {
  height: 18%;
}
</style>
<style>
/* html,
body {
  margin: 0;
  width: 100%;
  font-size: 50px;
  user-select: text;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
} */
/* #app {
  font-size: 14px;
} */
</style>
